import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'UPLOAD_QUITUS_FOURN',
  title: 'Comment télécharger le quitus et les documents de mon fournisseur ?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Le quitus est la synthèse du dossier administratif de votre fournisseur présent sur Attestation Légale.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Pour le télécharger :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous sur l’onglet « Fournisseurs »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_UPLOAD_QUITUS_FOURN/FR_UPLOAD_QUITUS_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur le bouton « Télécharger le quitus »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_UPLOAD_QUITUS_FOURN/FR_UPLOAD_QUITUS_FOURN_2.png`
  }]
};
